module.exports = __webpack_public_path__ + "images/dashboard-screenshot-1.png";